<template>

  <div id="page_slug">

    <h1>Dashboard</h1>

    <el-row :gutter="20"  class="content" style="margin-bottom:20px;">
      <el-col :span="8">
        <el-card class="box-card stat-card">
            <span class="figure shipped icon text-danger"><vue-material-icon name="access_alarm" :size="icon_size" /></span>
            <span class="figure shipped large-text text-danger">
              {{ overdue_orders }}
              <span class="small-text">Overdue Orders</span>
            </span>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card stat-card">
          <span class="figure shipped icon text-success"><vue-material-icon name="receipt" :size="icon_size" /></span>
          <span class="figure shipped large-text text-success">
              {{ orders_this_week }}
              <span class="small-text">7 Day Orders</span>
          </span>
        </el-card>
      </el-col>

      <el-col :span="8">
          <el-card class="box-card stat-card">
            <span class="figure shipped icon text-blue"><vue-material-icon name="photo_library" :size="icon_size" /></span>
            <span class="figure shipped large-text text-blue">
              {{ templates }}
              <span class="small-text">Active Templates</span>
            </span>
          </el-card>
      </el-col>
    </el-row> 

    <!-- Corporations: Seven Day Sales -->

    <el-row :gutter="30">
      <el-col :span="8" :md="24" class="bottom-spacer">
        <el-card class="box-card">
          <div slot="header" class="clearfix card-header-spacer">
            <span class="card-title">Corporations: Seven Day Sales</span>
          </div>

          <area-chart :prefix=config.currency :data="seven_day_sales" :colors="['#312783']"></area-chart>
        </el-card>
      </el-col>
    </el-row>

    <!-- Corporation: Sales By Store -->

    <!-- <el-row :gutter="30">
      <el-col :span="8" :md="24" class="bottom-spacer">
        <el-card class="box-card">
          <div slot="header" class="clearfix card-header-spacer">
            <span class="card-title">Sales By Store [To-Do: Add Dropdown To Select Corporation - Hardcoded ID Being Passed]</span>
          </div>

          <column-chart :prefix=config.currency :data="corporation_sales_by_stores" :colors="['#312783']"></column-chart>
        </el-card>
    </el-col> -->

    <!-- Top Five Corporations -->

    <el-row :gutter="20">

      <el-col :span="8" :md="12" class="bottom-spacer">
        <el-card class="box-card">
          <div slot="header" class="clearfix card-header-spacer">
            <span class="card-title">Top Spending Corporations</span>  
          </div>

          <el-table
            v-loading="loading_top_corporations"
            :data="top_five_corporations"
            :border="true"
            :striped="false"
            style="width: 100%">
            
            <el-table-column
              align="center"
              prop="name"
              label="Company Name">
            </el-table-column>

            <el-table-column
              align="center"
              prop="total"
              label="Orders Total">
              <template slot-scope="scope">
                  {{scope.row.total | toCurrency}}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>

      <!-- Top Five Products -->

      <el-col :span="8" :md="12" class="bottom-spacer">
        <el-card class="box-card">
          <div slot="header" class="clearfix card-header-spacer">
            <span class="card-title">Top Selling Products</span>  
          </div>

          <el-table
            v-loading="loading_top_products"
            :data="top_five_products"
            :border="true"
            :striped="false"
            style="width: 100%">

            <el-table-column
              align="center"
              prop="product_name"
              label="Product Name">
              <template slot-scope="scope">
                <router-link :to="{ name: 'ProductEdit', params: { id: scope.row.product_id }}">
                  <el-button type="text" >{{scope.row.product_name}}</el-button>
                </router-link>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="number_sold"
              label="Total Sold">
            </el-table-column>

            <el-table-column
              align="center"
              prop="total"
              label="Total Revenue">
              <template slot-scope="scope">
                {{scope.row.total | toCurrency}}
              </template>
            </el-table-column>

          </el-table>
        </el-card>
      </el-col>

      <!-- Corporation: Total Order Value By Hour -->

      <!-- <el-col :span="8" :md="12" class="bottom-spacer">
        <el-card class="box-card">
          <div slot="header" class="clearfix card-header-spacer">
            <span class="card-title">Total Order Value By Hour</span>
            <el-select 
              v-model="active_corporation_for_hourly" 
              size="small" 
              placeholder="Select" 
              style="float: right;"
              @change="getHourlyOrderValueByCorporation(active_corporation_for_hourly)">
              <el-option
                v-for="item in corporations"
                :key="item.corporateUID"
                :label="item.name"
                :value="item.corporateUID">
              </el-option>
            </el-select>
          </div>

          <line-chart :data="order_value_by_hour" :prefix=config.currency :colors="['#312783']" :messages="{empty: 'Please Choose Corporation From Dropdown'}"></line-chart>
        </el-card>
      </el-col> -->
    </el-row> 

    <pre>{{$data}}</pre> 

  </div>

</template>


<style scoped>

.icon {
    display:block;
    width: 45%;
    float:left;
}

.large-text {
    font-size:48px;
    font-weight: bold;
    text-align:right;
    display:block;
    width: 54.9%;
    float:right;
}

.small-text {
    font-size: 12px;
    font-weight:normal;
    display:block;
    margin-bottom:20px;
    color:#909399;
}


.text-success {
    color: #67C23A;
}

.text-danger {
    color: #F56C6C;
}

.text-blue {
    color: #409EFF;
}

</style>

<script>

  import Config from '@/store/Config.js';

  export default {
    data: function() {
      return {
        page_alias: 'Dashboard',
        page_slug: 'dashboard',

        config: Config.config,

        loading: false,
        loading_top_products: true,
        loading_top_corporations: true,
        icon_size: 65,
        corporations: [],

        //Top 3 Boxes:
        overdue_orders: 0,
        orders_this_week: 0,
        templates: 0,

        //Corporation: Sales By Store VARIABLES
        corporation_sales_by_stores: [],

        //Top Five VARIABLES
        top_five_products: [],
        top_five_corporations: [],

        //Corporation: Average Order Value By Month VARIABLES
        average_order_value_by_month: [],
        active_corporation: "Select Corporation",

        //Corporation: Total Order Value By Hour VARIABLES
        order_value_by_hour: [],
        active_corporation_for_hourly: "Select Corporation",

        //Last VARIABLES
        seven_day_sales: []
      }
    },

    mounted: function() {
      const me = this;
      me.getCorporations();

      //Top 3 Boxes:
      me.getOverdueOrders();
      me.getOrdersThisWeek()
      me.getTemplates();

      //Corporation: Sales By Store 
      me.getEachStoreSales();

      //Two Tables Below
      me.getTopFiveProducts();
      me.getTopFiveCorporations();

      //Bottom
      me.getSevenDaySales()
    },

    methods: {
      getCorporations: function() {
        console.log('Get Corporations Function');
        const me = this;

        me.$http.get(me.config.api + 'corporation', {params: {pagination: 1000}}).then(
            response => {
            console.log('Get Corporations Function - Success Getting Data');

            me.corporations = response.body.data;
        }, response => {
          console.log('Get Corporations Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      //Top 3 Boxes METHODS:

      getOverdueOrders: function(item) {
        const me = this;
        console.log('Get Overdue Orders Function');

        me.$http.get(me.config.api + 'number-overdue-order-items').then(
          response => {
          console.log('Get Overdue Orders Function - Success Getting Data');

          me.overdue_orders = response.body.data;
        }, response => {
          console.log('Get Overdue Orders Function - Error Getting Data');
        });
      },

      getOrdersThisWeek: function(item) {
        const me = this;
        console.log('Get Orders This Week Function');

        me.$http.get(me.config.api + 'orders-last-seven-days').then(
          response => {
          console.log('Get Orders This Week Function - Success Getting Data');

          me.orders_this_week = response.body.data;
        }, response => {
          console.log('Get Orders This Week Function - Error Getting Data');
        });
      },

      getTemplates: function(item) {
        const me = this;
        console.log('Get Templates Function');

        me.$http.get(me.config.api + 'total-number-of-templates').then(
          response => {
          console.log('Get Templates Function - Success Getting Data');

          me.templates = response.body.data;
        }, response => {
          console.log('Get Orders This Week Function - Error Getting Data');
        });
      }, 

      //END

      //Corporation: Sales By Store METHODS:

      getEachStoreSales: function() {
        console.log('Get Each Store Sales Function');

        const me = this;
        me.loading = true;

        me.$http.get(me.config.api + 'sales-by-store?api_id=3').then(
          response => {
          console.log('Get Each Store Sales Function - Success Getting Data');

          me.corporation_sales_by_stores = response.body.map(dataPoint => [dataPoint.api_store_id, dataPoint.goods_subtotal]);
        }, response => {
          console.log('Get Each Store Sales Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
          
          me.loading = false;
        });
      },

      //END

      getTopFiveProducts: function() {
        console.log('Get Top Five Products Function');
        const me = this;
        
        me.loading_top_products = true;

        me.$http.get(me.config.api + 'top-sellers').then(
          response => {
          console.log('Get Top Five Products Function - Success Getting Data')  

          me.top_five_products = response.body.data;
          
          me.loading_top_products = false;
        }, response => {
          console.log('Get Top Five Products Function - Error Getting Data');

          me.$notify({
              title: 'Error',
              message: response.statusText,
              type: 'error'
          });
          
          me.loading_top_products = false;
        });
      },

      getTopFiveCorporations: function() {
        console.log('Get Top Five Corporations Function');
        const me = this;

        me.loading_top_corporations = true;

        me.$http.get(me.config.api + 'top-five-corporations').then(
          response => {
          console.log('Get Top Five Corporations Function - Success Getting Data');

          me.top_five_corporations = response.body.data;
          
          me.loading_top_corporations = false;
        }, response => {
          console.log('Get Top Five Corporations Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
          
          me.loading_top_corporations = false;
        });
      },

      //Corporation: Average Order Value By Month METHODS

      getMonthlyAverageOrderValueByCorporation: function(item) {
        console.log('Get Monthly Average Order Value By Corporation');

        const me = this;
        me.loading = true;

        me.$http.get(me.config.api + 'monthly-average-order-value', {params: {api_corporate_id: item}}).then(
          response => {
          console.log('Get Monthly Average Order Value By Corporation - Success Getting Data')  

          var data = response.body.data;

          var object_removed_from_array = data.shift();

          var piece1 = Object.keys(object_removed_from_array);
          var piece2 = Object.values(object_removed_from_array);

          for (var i = 0; i < piece1.length; i++) {
              me.average_order_value_by_month.push([piece1[i], piece2[i]])
          }
        }, response => {
          console.log('Get Monthly Average Order Value By Corporation - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      //Corporation: Total Order Value By Hour METHODS

      getHourlyOrderValueByCorporation: function(item) {
        console.log('Get Hourly Order Value By Corporation');

        const me = this;
        me.loading = true;

        me.$http.get(me.config.api + 'corporation-hourly-sales', {params: {api_corporate_id: item}}).then(
            response => {
            console.log('Get Hourly Order Value By Corporation - Success Getting Data');

            me.order_value_by_hour = response.body.map(dataPoint => [dataPoint.hour, dataPoint.total])
        }, response => {
          console.log('Get Hourly Order Value By Corporation - Error Getting Data');
    
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
          
          me.loading = false;
        });
      },

      //END

      getSevenDaySales: function(item) {
        console.log('Get Seven Day Sales Function');

        const me = this;
        me.loading = true;

        me.$http.get(me.config.api + 'graph-orders').then(
          response => {
          console.log('Get Seven Day Sales Function - Success Getting Data');

          me.seven_day_sales = response.body.data.map(dataPoint => [dataPoint.date, dataPoint.total]);
        }, response => {
          console.log('Get Seven Day Sales Function - Error Getting Data');
          
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      } //LAST METHOD
    } //END METHODS
  }

</script>


// WEBPACK FOOTER //
// src/pages/dashboard/DashboardPage.vue